var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "AccountCircle_svg__a",
  width: 28,
  height: 28,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h28v28H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#AccountCircle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "M6.825 19.95q1.488-1.137 3.325-1.794A11.4 11.4 0 0 1 14 17.5q2.013 0 3.85.656a12.2 12.2 0 0 1 3.325 1.794 9 9 0 0 0 1.59-2.713q.569-1.516.569-3.237 0-3.879-2.728-6.606Q17.88 4.667 14 4.667T7.394 7.394 4.667 14q0 1.72.569 3.237a9 9 0 0 0 1.59 2.713M14 15.167q-1.72 0-2.902-1.182-1.18-1.181-1.181-2.902 0-1.72 1.181-2.902Q12.28 7.001 14 7q1.721 0 2.902 1.181t1.181 2.902-1.18 2.902T14 15.167m0 10.5a11.4 11.4 0 0 1-4.55-.92 11.8 11.8 0 0 1-3.704-2.493 11.8 11.8 0 0 1-2.494-3.704A11.4 11.4 0 0 1 2.334 14q0-2.42.918-4.55a11.8 11.8 0 0 1 2.494-3.704A11.8 11.8 0 0 1 9.45 3.252 11.4 11.4 0 0 1 14 2.333q2.42 0 4.55.919a11.8 11.8 0 0 1 3.704 2.494 11.8 11.8 0 0 1 2.494 3.704 11.4 11.4 0 0 1 .919 4.55q0 2.42-.919 4.55a11.8 11.8 0 0 1-2.494 3.704 11.8 11.8 0 0 1-3.704 2.494 11.4 11.4 0 0 1-4.55.919m0-2.334q1.545 0 2.917-.452a8.8 8.8 0 0 0 2.508-1.298 8.8 8.8 0 0 0-2.508-1.298A9.3 9.3 0 0 0 14 19.833q-1.546 0-2.916.452a8.8 8.8 0 0 0-2.509 1.298 8.8 8.8 0 0 0 2.509 1.298 9.3 9.3 0 0 0 2.916.452m0-10.5q.759 0 1.254-.496.495-.495.496-1.254 0-.758-.496-1.254-.495-.495-1.254-.496-.758 0-1.254.496-.495.496-.496 1.254 0 .759.496 1.254.496.496 1.254.496"
}))));
export default SvgAccountCircle;